import React from 'react';

interface IconProps {
  size?: number;
}

// Simple Ranking Icon Component
export const RankingIcon: React.FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 4V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h1a2 2 0 0 1 2 2v3c0 2.4-1.7 4.4-4 4.9V17h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v-3.1c-2.3-.5-4-2.5-4-4.9V6a2 2 0 0 1 2-2h1z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
  </svg>
);
